import React from 'react';

export const Table = ({ className = '', children }) => (
  <div className={`bg-succession-bg-primary border border-succession-border rounded-lg overflow-hidden ${className}`}>
    <div className="overflow-x-auto">
      <table className="w-full">{children}</table>
    </div>
  </div>
);

export const Thead = ({ children }) => (
  <thead>
    <tr className="border-b border-succession-border" style={{ background: 'var(--succession-bg-tertiary)' }}>
      {children}
    </tr>
  </thead>
);

export const Th = ({ sticky = false, className = '', children }) => (
  <th
    className={`py-3 px-4 font-semibold text-sm text-succession-text-primary ${sticky ? 'text-left sticky left-0 z-10' : 'text-right'} ${className}`}
    style={sticky ? { background: 'var(--succession-bg-tertiary)' } : undefined}
  >
    {children}
  </th>
);

export const Tr = ({ className = '', style, children }) => (
  <tr className={`border-b border-succession-border ${className}`} style={style}>{children}</tr>
);

export const Td = ({ sticky = false, align = 'right', className = '', style, bg, children }) => {
  const computedStyle = sticky
    ? { ...(style || {}), background: bg || (style && style.background) || 'var(--succession-bg-primary)' }
    : style;
  return (
    <td
      className={`py-2 px-4 text-sm ${align === 'right' ? 'text-right' : ''} ${sticky ? 'sticky left-0 z-10' : ''} ${className}`}
      style={computedStyle}
    >
      {children}
    </td>
  );
};

export const SectionRow = ({ title, bg, children }) => (
  <Tr style={{ background: bg }}>
    <Td sticky align="left" className="font-semibold text-succession-text-primary">{title}</Td>
    {children}
  </Tr>
);

export default { Table, Thead, Th, Tr, Td, SectionRow };


